import script from "./Balance.vue?vue&type=script&setup=true&lang=ts"
export * from "./Balance.vue?vue&type=script&setup=true&lang=ts"

import "./Balance.vue?vue&type=style&index=0&id=1841a5a9&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1841a5a9"]])

export default __exports__